import React, {useMemo} from 'react';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import {B2BUserScreens} from '@buncha/B2B/navigation/types';
import {Box} from '@buncha/components/core/view';
import {CustomImage} from '@buncha/components/core/Image';
import {H5Text} from '@buncha/components/core/text';
import {Modules} from '@buncha/utils/types';
import {OrderItemStatus} from '@buncha/batchDetails/types';
import {styles} from './styles';
import {useGetLocale} from '@buncha/localization/hooks';

interface Props {
  status: OrderItemStatus;
}

const NoItemsUI = (props: Props) => {
  const {status} = props;
  const theme = useColorThemeType();
  const muliFont = useFontTheme();
  const {body} =
    useGetLocale(Modules.B2BUserOrder, B2BUserScreens.OrderItemInfo) ?? {};

  const imgUrl =
    status === OrderItemStatus.picked || status === OrderItemStatus.missing
      ? require('@buncha/resource/images/bagEmpty.png')
      : require('@buncha/resource/images/bagFull.png');

  const subHeaderText = useMemo(() => {
    switch (status) {
      case OrderItemStatus.picked:
        return body?.noItemsPicked;
      case OrderItemStatus.missing:
        return body?.noItemsSubstituted;
      case OrderItemStatus.dropped:
        return body?.noItemsUnavailable;
      case OrderItemStatus.notPicked:
        return body?.noItemsNotPicked;
      default:
        return '';
    }
  }, [
    body?.noItemsUnavailable,
    body?.noItemsNotPicked,
    body?.noItemsPicked,
    body?.noItemsSubstituted,
    status,
  ]);
  return (
    <Box style={styles.noItemsContainer}>
      <CustomImage
        resizeMode="contain"
        style={styles.noItemsImage}
        source={imgUrl}
      />
      <H5Text
        style={{
          color: theme?.text.blue[300],
          fontFamily: muliFont[400].normal,
        }}>
        {subHeaderText}
      </H5Text>
    </Box>
  );
};

export default NoItemsUI;
